import { ROLE_NAME } from 'enums';

interface IRoleRestrictedRoute {
  roles: ROLE_NAME[];
}

// Single source of truth for who may open an organization page. The menu, the
// first-page redirect and the route itself all ask here, so a hidden tab cannot be
// reached by typing its URL.
const canAccessManageOrganizationRoute = (
  route: IRoleRestrictedRoute,
  roleName: string | undefined,
): boolean => Boolean(roleName) && (route.roles as string[]).includes(roleName as string);

export { canAccessManageOrganizationRoute };
